import axios from 'axios';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add JWT token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('authToken');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: async (username, password) => {
    const response = await apiClient.post(API_ENDPOINTS.LOGIN, {
      username,
      password,
    });
    // API returns { success: true, data: { accessToken, tokenType } }
    return response.data.data;
  },
};

// Prompts API
export const promptsAPI = {
  list: async (limit = 50, offset = 0) => {
    const response = await apiClient.get(API_ENDPOINTS.PROMPTS, {
      params: { limit, offset },
    });
    // API returns { success: true, data: { prompts: [...] }, pagination: {...} }
    return {
      prompts: response.data.data.prompts,
      pagination: response.data.pagination,
    };
  },

  get: async (promptName) => {
    const response = await apiClient.get(API_ENDPOINTS.PROMPT(promptName));
    // API returns { success: true, data: { id, name, content } }
    return response.data.data;
  },

  create: async (promptData) => {
    const response = await apiClient.post(API_ENDPOINTS.PROMPTS, promptData);
    // API returns { success: true, data: { id, name, content } }
    return response.data.data;
  },

  update: async (promptName, promptData) => {
    const response = await apiClient.put(API_ENDPOINTS.PROMPT(promptName), promptData);
    // API returns { success: true, data: { id, name, content } }
    return response.data.data;
  },

  delete: async (promptName) => {
    await apiClient.delete(API_ENDPOINTS.PROMPT(promptName));
  },
};

export default apiClient;
